import {Grid, Card, CardContent, Button} from '@mui/material'

import { Plus } from 'react-feather'
import { useFechInitVehicleApplies } from './hooks';
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { VehiclesAppliesTable } from './VehiclesTable/VehiclesTable';
import { VehicleForm } from './VehicleForm/VehicleForm';
import { LinearLoading } from 'common';

const VehiclesApplies = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehicleApplies({location, paramsURL})

  const {
    globalStates,
    Actions,
    FetchData
} = useFetchInit

const { showForm} = globalStates

const {handleClickShowForm} = Actions

const { fetchAllVehicleApplication: { loadingFetchVehicleApplications } } = FetchData

  return (
    // <VehicleAppliesProvider >
    <AllowedAccess permissions={['102_VEHICULOS_SOLICITUDES']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {(!showForm)&&(
          <div className='panel-body' id='listadoregistros'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent >
                    <div className='h4 mt-1 mb-1'> Solicitudes de Vehiculos</div>
                    <div className="border-bottom border-dark"></div>
        
                    <Button
                      startIcon={<Plus />}
                      size='medium'
                      type='button'
                      variant='contained'
                      color='primary'
                      sx={{ marginTop: 4 }}
                      onClick={() => handleClickShowForm('EDITABLE')}
                    >
                      Agregar
                    </Button>
        
                    <div className="pt-4"></div>
                    {loadingFetchVehicleApplications && <LinearLoading />}
                    <VehiclesAppliesTable
                        useFetchInit={useFetchInit}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        )}
        {(showForm) && (
          <>
              <div className='panel-body' id='formularioregistros'>
                  <VehicleForm 
                      useFetchInit={useFetchInit}
                  />
              </div>
          </>
        )}

            {/* {activeForm ?
              // <VehicleApplyForm setActiveForm={setActiveForm} />
              :
            <Card>
              <CardContent >
                <Grid>
                  <div className='h4 mt-1 mb-1'> Solicitudes de Vehiculos</div>
                  <div className="border-bottom border-dark"></div>
                </Grid>
                <Grid style={{ marginBottom: 8 }}> 
                  <Grid md='2'>    
                    <Button
                      startIcon={<Plus />}
                      size='medium'
                      type='button'
                      variant='contained'
                      color='primary'
                      sx={{ marginTop: 4 }}
                      onClick={() => setActiveForm(x => !x)}>
                      Agregar
                    </Button>
                  </Grid>
                </Grid>
                {/* <VehiclesAppliesTable activeForm={setActiveForm} /> */}
              {/* </CardContent> */}
            {/* </Card> */}
          {/* } */}

      </div>
    </AllowedAccess>

  )
}

export {
    VehiclesApplies
}
